import { Outlet } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

import { Feature } from "graphql_globals";
import { useActiveOrganization } from "common/account/active_organization";
import { SidebarTabLink } from "common/sidebar";
import { useQuery } from "util/graphql";
import { SettingsHeader, SettingsPageWrapper, SettingsTitle } from "common/settingsv2/common";
import { useA11y } from "common/accessibility";
import { useDocumentTitles } from "util/document_title";

import AccountAuthOptionsQuery, {
  type Organization_organization_Organization as OrganizationType,
} from "./mfa/account_auth_options_query.graphql";

const TITLE = (
  <FormattedMessage id="a301adda-76f8-45d2-89d3-3a659b40e807" defaultMessage="Team Security" />
);
export const SECURITY_ROUTE = "security";

function SettingsSidebarSecurityLinkInner({ organization }: { organization: OrganizationType }) {
  const { featureList } = organization;
  const hasSecurity =
    featureList.includes(Feature.SINGLE_SIGN_ON) || featureList.includes(Feature.TEAM_MFA);
  return hasSecurity ? (
    <SidebarTabLink to={SECURITY_ROUTE}>
      <FormattedMessage id="5c0e31a9-ca1e-4a81-a259-d26ae074debb" defaultMessage="Team Security" />
    </SidebarTabLink>
  ) : null;
}

export function SettingsSidebarSecurityLink() {
  const [activeOrganizationId] = useActiveOrganization();
  const { loading, data } = useQuery(AccountAuthOptionsQuery, {
    variables: { organizationId: activeOrganizationId! },
  });
  const organization = data?.organization as OrganizationType;
  return loading ? null : <SettingsSidebarSecurityLinkInner organization={organization} />;
}

export function SecuritySettings() {
  useA11y().useDocumentEntitler({
    title: useIntl().formatMessage(useDocumentTitles().settingsTeamSecurity),
  });
  return (
    <>
      <SettingsPageWrapper>
        <SettingsHeader title={TITLE} />

        <SettingsTitle>
          <FormattedMessage
            id="e832cdff-9d64-4510-a157-e79dc86b9349"
            defaultMessage="Login Security"
          />
        </SettingsTitle>

        <Outlet />
      </SettingsPageWrapper>
    </>
  );
}
